export enum CaseParticipantStatus {
  // Zaproszenie
  Invitation = 0,
  // Przyjęte zaproszenie, oczekuje
  // na potwierdzenie przez zapraszającego / wygenerowanie kluczy
  WaitingToConfirm = 1,
  Active = 10,
  Removed = 99,
}
